// Mantis #1378 — M001-D029 §3.3/§5 (F0312, T-M001-RASYNC-013): grants are
// display-only {kind, label} pairs. This component renders labels; it never
// renders a SID, card code, NAS identifier or share path, and attaches no
// semantics of its own to a grant.
import React from 'react';
import { grantLabel } from './normalisers';
import './realmAuthority.css';

const KIND_CLASS = { door: 'ra-grant--door', radius: 'ra-grant--radius' };

export default function GrantsSummary({ grants }) {
  // Contract distinguishes null (RA published no grants block at all) from
  // [] (RA published a grants block with zero grants); this summary renders
  // the same honest "none" line for both — there is nothing to list either way.
  const list = grants ?? [];
  if (!list.length) {
    return <span className="ra-grants ra-grants--empty">No grants published</span>;
  }
  return (
    <ul className="ra-grants" aria-label="Grants summary">
      {list.map((grant, index) => (
        <li
          key={`${grant.kind}-${grant.label}-${index}`}
          className={`ra-grant ${KIND_CLASS[grant.kind] || 'ra-grant--unrecognised'}`}
        >
          {grantLabel(grant)}
        </li>
      ))}
    </ul>
  );
}
